import {
  Box,
  Button,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import TextFieldComponent from "../../../../Components/TextFieldComponent";
import DropdownComponent from "../../../../Components/DropdownComponent";
import { TaxDropdown } from "../../../../redux/Thunk/ClientModule/ClientThunk";
import { CurrencyCode } from "../../../../redux/Thunk/AdminModule/AdminThunk";
import Btn from "../../../../Components/Ui_elements/Btn";
import { validateFields } from "../../../../Helper/ValidateFields";
import {
  getUserPaymentonEdit,
  savePayment,
  updatePayment,
} from "../../../../redux/Thunk/externalResourceThunk";
import { useLocation, useParams } from "react-router-dom";
import authApi from "../../../../redux/authApi";

const Step4 = ({ registerSubmit }) => {
  const { id } = useParams();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const cId = searchParams.get("c_id");
  const dispatch = useDispatch();
  const { taxname } = useSelector(state => state.root.ClientModule);
  console.log('taxname', taxname)
  const { currencyCode } = useSelector(state => state.root.AdminModule);
  const { new_external_created, external_payment_data } = useSelector(
    state => state.root.ExternalResource
  );
  const { edit_external_resource_data } = useSelector(
  state => state.root.ExternalResource
);


  const newId = id ? id : cId;
  const [errors, setErrors] = useState({});

  const [formData, setFormData] = useState({
    tax_id: "",
    country_code: "",
    tax_rate: 0,
    tax_type: "non-taxable",
    payment_method: "Bank Transfer",
    bank_name: "",
    address: "",
    holder_name: "",
    currency: "",
    iban: "",
    bic: "",
    bank_code: "",
  });
  const [checkVatData, setCheckVatData] = useState(null);
  useEffect(() => {
    if (newId) {
      dispatch(getUserPaymentonEdit(newId));
    }
    dispatch(TaxDropdown());
    dispatch(CurrencyCode());
  }, [dispatch]);

  const normalizeTaxType = (taxType) => {
    const map = {
      "EU without VAT": "non-taxable",
      "EU with VAT": "non-taxable",
      "Non-taxable": "non-taxable",
    };

    return map[taxType] || taxType || "non-taxable";
  };


  useEffect(() => {
    if ((external_payment_data && id) || cId) {
      const paymentInfo = JSON.parse(external_payment_data?.data?.vPaymentInfo || "{}");
      console.log('paymentInfo', paymentInfo)
      const bankInfo = JSON.parse(external_payment_data?.data?.vBankInfo || "{}");

      setFormData({
        tax_id: paymentInfo?.tax_id || "",
        country_code: paymentInfo?.tax_id ? paymentInfo.tax_id.substring(0, 2).toUpperCase() : "",
        tax_rate: external_payment_data?.data?.tax_rate || 0,
        tax_type: normalizeTaxType(paymentInfo?.tax_type),
        payment_method: bankInfo?.payment_method || "Bank Transfer",
        bank_name: bankInfo?.bank_name || "",
        address: bankInfo?.address || "",
        holder_name: bankInfo?.holder_name || "",
        currency: bankInfo?.currency_code || "",
        iban: bankInfo?.iban || "",
        bic: bankInfo?.bic || "",
        bank_code: bankInfo?.bank_code || "",
      });
    }
  }, [external_payment_data?.data]);

  //const taxationTypeArray__ = ["EU without VAT", "EU with VAT", "Norwegian MVA", "non-taxable"];
  const taxationTypeArray = { "non-taxable": "Non-taxable", "Norwegian MVA": "Norwegian MVA", };

  const paymentMethodArray = ["Bank Transfer"];
  // formfields for the validation purpose, add the fields and the display name.
  const formFields = [
    { name: "tax_type", label: "Taxation Type" },
    { name: "bank_name", label: "Bank Name" },
    { name: "address", label: "Bank Address" },
    { name: "holder_name", label: "Holder Name" },
    { name: "iban", label: "IBAN" },
    { name: "bic", label: "SWIFT/BIC" },
  ];
  const [idExitst, setIdExist] = useState(0);
  useEffect(() => {
    const taxLength = formData.tax_id?.length || 0;

    if (taxLength === 0) {
      setIdExist(0); // or 0 or false — based on how you use it
    } else {
      setIdExist(taxLength);
    }
  }, [formData.tax_id]);

  const handleInputChange = event => {
    const { name, value } = event.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
      ...(name === "tax_id" && {
        country_code: value.substring(0, 2).toUpperCase(),
      }),
    }));
    setErrors(prevErrors => ({ ...prevErrors, [name]: "" }));
  };

  const handleSubmit = e => {
    const newErrors = validateFields(formData, formFields);

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    const countryCode = formData.tax_id ? formData.tax_id.substring(0, 2).toUpperCase() : "";

    // Construct the payload
    const payload = {
      vPaymentInfo: JSON.stringify({
        tax_id: formData.tax_id,
        country_code: countryCode,
        tax_type: formData.tax_type,
      }),
      vBankInfo: JSON.stringify({
        payment_method: formData.payment_method,
        currency_code: formData.currency,
        bank_name: formData.bank_name,
        address: formData.address,
        holder_name: formData.holder_name,
        iban: formData.iban,
        bic: formData.bic,
        bank_code: formData.bank_code,
        paypal_address: "", // Default empty string
      }),
      iUserId: newId,
      iType: 1,
      tax_rate: Number(formData.tax_rate) || 0, // Ensuring tax_rate is a number
    };
    if (id) {
      dispatch(updatePayment(payload));
    } else {
      dispatch(savePayment(payload));
    }
    return true;
  };

  const handleCheckVat = async () => {
    const vatId = formData.tax_id?.trim();

    if (!vatId || vatId.length <= 3) {
      setErrors(prev => ({
        ...prev,
        tax_id: "Please enter more than 3 charecter",
      }));
    }

    const countryCode = vatId.slice(0, 2).toUpperCase();
    const vatNumber = vatId.slice(2);

    try {
      const response = await authApi.get(`getVatcount/${countryCode}/${vatNumber}`);
      if (response?.data?.data?.valid === true) {
        setCheckVatData(response?.data);
        setErrors({ tax_id: "" });
      } else {
        setErrors(prev => ({
          ...prev,
          tax_id: "Unable to get vat information, please try again",
        }));
      }
    } catch (error) {
      console.log("error: ", error);
    }
  };
  const taxOption__ = taxname?.map(option => ({
    value: option.tax_id,
    label: `${option.tax_name} (${option.tax_percentage}%)`,
  }));
  const taxOption = [
    { value: "", label: "Please select" }, // Default option
    ...(taxname?.map(option => ({
      value: option.tax_id,
      label: `${option.tax_name} (${option.tax_percentage}%)`,
    })) || [])
  ];


  const taxationTypeOption = Object.entries(taxationTypeArray).map(
    ([value, label]) => ({
      value,
      label,
    })
  );


  const paymentMethodOption = paymentMethodArray?.map(option => ({
    value: option,
    label: option,
  }));

  const currencyOptions = Object?.entries(currencyCode)?.map(([key, currency]) => ({
    label: `${key}`,
    value: `${key}`,
  }));

  useEffect(() => {
    registerSubmit(handleSubmit);
  }, [formData]);

  useEffect(() => {
    const country = getCountryFromProfile();
    console.log('country', country)

    if (!country) return;

    setFormData(prev => {
      // Norway always wins
      if (country === "Norway" && prev.tax_type !== "Norwegian MVA") {
        return {
          ...prev,
          tax_type: "Norwegian MVA",
        };
      }

      // Non-Norway default
      if (country !== "Norway" && !prev.tax_type) {
        return {
          ...prev,
          tax_type: "non-taxable",
        };
      }

      return prev;
    });
  }, [edit_external_resource_data?.data]);



  const getCountryFromProfile = () => {
    try {
      const address = edit_external_resource_data?.data?.address1Detail;
      if (!address) return "";

      const parsed = JSON.parse(address);
      const countryField = parsed.find(
        item => item.id === "address1_country"
      );

      return countryField?.value || "";
    } catch {
      return "";
    }
  };




  return (
    <Box sx={{ background: "#fff", p: 2, borderRadius: 2 }}>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          {/*-------------------- Account information --------------------*/}
          <Grid item xs={12} md={6}>
            <Typography variant="h6" color="grey" mb={2}>
              Account Information
            </Typography>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={8}>
                <TextFieldComponent
                  id="tax_id"
                  name="tax_id"
                  label="Vat Number"
                  onChange={handleInputChange}
                  value={formData.tax_id}
                  isNotMandatory={true}
                  error={errors.tax_id}
                  fullWidth
                />
              </Grid>
              <Grid item xs={4} sx={{ textAlign: "right", mt: 3 }}>
                <Button
                  onClick={handleCheckVat}
                  variant="contained"
                  disabled={idExitst == 0}
                  sx={{ whiteSpace: "nowrap", minWidth: "100px" }}
                >
                  Check
                </Button>
              </Grid>
            </Grid>
            {checkVatData && (
              <TableContainer component={Paper} sx={{ mt: 2, mb: 3 }}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <strong>Country</strong>
                      </TableCell>
                      <TableCell>
                        <strong>VAT Number</strong>
                      </TableCell>
                      <TableCell>
                        <strong>Company Name</strong>
                      </TableCell>
                      <TableCell>
                        <strong>Company Address</strong>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell>{checkVatData.country_code}</TableCell>
                      <TableCell>{checkVatData.vat_number}</TableCell>
                      <TableCell>{checkVatData.company_name || "-"}</TableCell>
                      <TableCell>{checkVatData.company_address || "-"}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            )}

            <Box sx={{ mt: 2, mb: 2 }}>
              <DropdownComponent
                label="Tax Rate"
                name="tax_rate"
                value={formData.tax_rate}
                onChange={handleInputChange}
                options={taxOption || []}
                isNotMandatory={true}
                error={errors.tax_rate || ""}
              />
            </Box>
            <Box sx={{ mt: 2, mb: 2 }}>
              <DropdownComponent
                label="Taxation Type"
                name="tax_type"
                value={formData.tax_type}
                onChange={handleInputChange}
                options={taxationTypeOption || []}
                error={errors.tax_type || ""}
              />
            </Box>
          </Grid>
          {/*------------------------- Bank Details ------------------------*/}
          <Grid item xs={12} md={6}>
            <Typography variant="h6" color="grey" mb={2}>
              Bank Details
            </Typography>
            <Box sx={{ mt: 2, mb: 2 }}>
              <DropdownComponent
                label="Payment Method"
                name="payment_method"
                value={formData.payment_method}
                onChange={handleInputChange}
                options={paymentMethodOption || []}
                error={errors.payment_method || ""}
                isNotMandatory={true}
                disabled
              />
            </Box>

            <Box sx={{ mt: 2, mb: 2 }}>
              <TextFieldComponent
                id="bank_name"
                name="bank_name"
                label="Bank Name"
                onChange={handleInputChange}
                value={formData.bank_name}
                error={errors?.bank_name || ""}
                fullWidth
              />
            </Box>
            <Box sx={{ mt: 2, mb: 2 }}>
              <TextFieldComponent
                id="address"
                name="address"
                label="Address"
                onChange={handleInputChange}
                value={formData.address}
                error={errors?.address || ""}
                fullWidth
              />
            </Box>
            <Box sx={{ mt: 2, mb: 2 }}>
              <TextFieldComponent
                id="holder_name"
                name="holder_name"
                label="Account Holder"
                onChange={handleInputChange}
                value={formData.holder_name}
                error={errors?.holder_name || ""}
                fullWidth
              />
            </Box>
            {/* <DropdownComponent
              label="Currency Code"
              name="currency"
              value={formData?.currency}
              onChange={handleInputChange}
              options={currencyOptions}
              searchable={true}
              isNotMandatory={true}
              error={errors.currency || ""}
            /> */}
            <Box sx={{ mt: 2, mb: 2 }}>
              <TextFieldComponent
                id="iban"
                name="iban"
                label="IBAN"
                onChange={handleInputChange}
                value={formData.iban}
                error={errors?.iban || ""}
                fullWidth
              />
            </Box>
            <Box sx={{ mt: 2, mb: 2 }}>
              <TextFieldComponent
                id="bic"
                name="bic"
                label="SWIFT/BIC"
                onChange={handleInputChange}
                value={formData.bic}
                error={errors?.bic || ""}
                fullWidth
              />
            </Box>
            {/* <TextFieldComponent
              id="bank_code"
              name="bank_code"
              label="Routing Number"
              onChange={handleInputChange}
              value={formData.bank_code}
              isNotMandatory={true}
              error={errors?.bank_code || ""}
              fullWidth
            /> */}
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};

export default Step4;
